import { videoPlayerStore, VideoPlayerStore } from '@stores/VideoPlayer';
import { observer } from 'mobx-react';
import { VideoPlayerRef } from '../VideoPlayer/VideoPlayer';
import type { TimelineCommentMark } from './components/CommentMarkers/CommentMarkers';
import { TimelineSkeleton } from './TimelineSkeleton';
import { VirtualizedVideoTimeline } from './VirtualizedVideoTimeline';

type VideoTimelineProps = {
  duration: number;
  videoPlayerRef: React.RefObject<VideoPlayerRef | null>;
  store?: VideoPlayerStore;
  mediaId: string;
  libraryId: string;
  isLoading?: boolean;
  compactZoom?: boolean;
  zoomLevel?: number;
  onZoomLevelChange?: (level: number) => void;
  /** Comment anchors to draw along the strip, in absolute media seconds. */
  comments?: TimelineCommentMark[];
  selectedCommentId?: string | null;
  onSelectComment?: (commentId: string) => void;
};
export const VideoTimeline = observer(function VideoTimeline({
  duration,
  videoPlayerRef,
  store = videoPlayerStore,
  mediaId,
  libraryId,
  isLoading = false,
  compactZoom,
  zoomLevel,
  onZoomLevelChange,
  comments,
  selectedCommentId = null,
  onSelectComment,
}: VideoTimelineProps) {
  if (isLoading) {
    return <TimelineSkeleton />;
  }

  return (
    <VirtualizedVideoTimeline
      duration={duration}
      videoPlayerRef={videoPlayerRef}
      store={store}
      mediaId={mediaId}
      libraryId={libraryId}
      compactZoom={compactZoom}
      zoomLevel={zoomLevel}
      onZoomLevelChange={onZoomLevelChange}
      comments={comments}
      selectedCommentId={selectedCommentId}
      onSelectComment={onSelectComment}
    />
  );
});
